import { render, staticRenderFns } from "./ForumlaEidtor.vue?vue&type=template&id=6e022432&scoped=true"
import script from "./ForumlaEidtor.vue?vue&type=script&lang=js"
export * from "./ForumlaEidtor.vue?vue&type=script&lang=js"
import style0 from "./ForumlaEidtor.vue?vue&type=style&index=0&id=6e022432&prod&scoped=true&lang=scss"
import style1 from "./ForumlaEidtor.vue?vue&type=style&index=1&id=6e022432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e022432",
  null
  
)

export default component.exports